// React
import React from 'react'
import PropTypes from 'prop-types'

// Components
import Img from 'ui/elements/Img'
import FocalImage from 'ui/components/FocalImage'

// Shared
import { optimizeImageUrl } from 'shared/utils/optimizeImageUrl'

const OptimizedImage = ({ focal, src, ...otherProps }) => {
  const optimizedSrc = optimizeImageUrl(src, { ...otherProps })

  if (focal) {
    return <FocalImage {...otherProps} url={optimizedSrc} coordinates={focal} />
  }

  return <Img {...otherProps} src={optimizedSrc} />
}

OptimizedImage.displayName = 'OptimizedImage'

OptimizedImage.propTypes = {
  src: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  quality: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  format: PropTypes.oneOf(['jpg', 'jpeg', 'png', 'webp']),
  focal: PropTypes.shape({
    x: PropTypes.any,
    y: PropTypes.any
  })
}

export default OptimizedImage
